import { render } from "./Scale.vue?vue&type=template&id=64977cc8"
import script from "./Scale.vue?vue&type=script&lang=js"
export * from "./Scale.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__